import React from 'react';

import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import TextInput from 'components/textinput/TextInput';

const FieldLabelField = ({
    value,
    theme,
    error,
    onChange,
}) => (

    <ModalField>

        <ModalLabel label="Label" />
        <ModalHint hint="The primary label for the field." />

        <TextInput
            value={value}
            onChange={(e) => onChange(e.target.value)}
            maxLength={100}
            autoFocus
            error={!!error}
            helperText={error}
        />

    </ModalField>
);

export default FieldLabelField;
